import { Field, useFormikContext } from "formik";
import React, { FC } from 'react';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import CustomSettingIcon from '../../images/Custom Setting.svg';
import InheritPresetIcon from '../../images/Inherited from Preset.svg';
import ReportImage from '../../images/Reports.svg';
import EntityHierarchy from "../entityHierarchy/entityHierarchy";
import Label from "../label/label";
import { MusteringReportTotals } from "../../models/MusteringReportTotals";
import { getFormattedDate } from "../../services/utilities/dateFormatting";

type ReportProps = {
    isGeneralMusteringReport?: boolean;
    dataTotals?: MusteringReportTotals
}

const ReportEditCard: FC<ReportProps> = ({isGeneralMusteringReport = false, dataTotals}) => {
    const { values } = useFormikContext<any>();
    const { translate } = useLocale();

    return (
        <div className="w-full py-1 px-2 flex items-center bg-white">
            <img className="h-8 mx-4 shrink-0" src={ReportImage} alt="report" />
            <div className="flex flex-col">
                <div className="flex items-center space-x-1">
                    <EntityHierarchy title={values.name} labelOnly={true} />
                    <img className="h-5" src={values.isTemplate ? InheritPresetIcon : CustomSettingIcon} alt="status" />
                </div>
                <div className="flex flex-row items-center text-sm text-gray-700 gap-2" id="typeLabel">
                    <p>{values.type}</p>
                    {values.lastExecutedTime &&
                        <>
                            <span className="text-gray-400">·</span>
                            <span id="lastRunLabel">
                                <Label htmlFor="lastRun" className="inline">{translate.byKey(TranslationKeys.lastRun)}:</Label>
                                <span className="ml-1">{`${getFormattedDate(values.lastExecutedTime.replaceAll('-','').substring(0,8))} at ${values.lastExecutedTime.split("T")[1].substring(0,5)}`}</span>
                            </span>
                        </>
                    }
                </div>
            </div>

            {isGeneralMusteringReport && 
                <div className="m-auto w-1/2">
                    <div className="flex flex-row justify-around">
                        <div className="flex text-sm text-gray-700" style={{width: "30%"}}>
                            <Label htmlFor="totalPersonnelOnSite">
                                {translate.byKey(TranslationKeys.totalPersonnelOnSite)}:
                            </Label>
                            <Field
                                type="number"
                                name="totalPersonnelOnSite"
                                id="totalPersonnelOnSiteId"
                                value={dataTotals?.totalOnSite}
                                className="flex flex-row text-center w-1/2 bg-gray-input"
                                disabled
                            />
                        </div>
                        <div className="flex text-sm text-gray-700" style={{width: "30%"}}>
                            <Label htmlFor="totalPersonnelMustered">
                                {translate.byKey(TranslationKeys.totalPersonnelMustered)}:
                            </Label>
                            <Field
                                type="number"
                                name="totalPersonnelOnMustered"
                                id="totalPersonnelMusteredId"
                                value={dataTotals?.totalMustered}
                                className="flex flex-row text-center w-1/2 bg-gray-input"
                                disabled
                            />
                        </div>
                        <div className="flex text-sm text-gray-700" style={{width: "30%"}}>
                            <Label htmlFor="totalPersonnelUnaccountedFor">
                                {translate.byKey(TranslationKeys.totalPersonnelUnaccountedFor)}:
                            </Label>
                            <Field
                                type="number"
                                name="totalPersonnelUnaccountedFor"
                                id="totalPersonnelUnaccountedForId"
                                value={(dataTotals?.unaccountedWithExited) ?? 0}
                                className={`flex flex-row text-center w-1/2 ${((dataTotals?.unaccountedWithExited) ?? 0) > 0 ? 'bg-red-300' : 'bg-gray-input'}`}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default ReportEditCard;
